import React, { useState, useEffect } from "react";
import { getMetrics } from "../api/services";
import { Card, Loading, KpiCard } from "../components/common/UI";
import { DoughnutChart } from "../components/charts/SimpleCharts";
import { fmtNum, fmtPct } from "../utils/format";
import styles from "./pages.module.css";

export default function Traffic() {
  const [period, setPeriod] = useState("all");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setLoading(true);
    getMetrics(period).then((d) => {
      if (!active) return;
      setData(d);
      setLoading(false);
    });
    const reload = () => getMetrics(period).then((d) => setData(d));
    window.addEventListener("ingest-done", reload);
    return () => { active = false; window.removeEventListener("ingest-done", reload); };
  }, [period]);

  if (loading && !data) return <Loading />;

  if (!data || !data.available || !data.sites?.length) {
    return (
      <div className={styles.page}>
        <h1 className={styles.pageTitle}>Трафик</h1>
        <Card>
          <div style={{ color: "var(--text-mute)", padding: 20 }}>
            Данные Яндекс.Метрики ещё не собраны. Нажми «Обновить данные» вверху.
          </div>
        </Card>
      </div>
    );
  }

  const months = data.months || [];

  return (
    <div className={styles.page}>
      <div className={styles.pageHead}>
        <div>
          <h1 className={styles.pageTitle}>Трафик</h1>
          <div className={styles.pageSub}>Посещаемость сайтов из Яндекс.Метрики</div>
        </div>
      </div>

      {months.length > 0 && (
        <div className={styles.tabs} style={{ alignSelf: "flex-start", flexWrap: "wrap" }}>
          {months.map((m) => (
            <button
              key={m.key}
              className={`${styles.tab} ${period === m.key ? styles.tabActive : ""}`}
              onClick={() => setPeriod(m.key)}
            >
              {m.label}
            </button>
          ))}
        </div>
      )}

      {data.sites.map((s) => {
        const bySource = Object.entries(s.by_source || {}).sort((a, b) => b[1] - a[1]);
        const searches = s.search_phrases || [];
        return (
          <Card key={s.site} title={s.title}>
            <div className={styles.kpiGrid} style={{ marginBottom: 16 }}>
              <KpiCard label="Визиты" value={fmtNum(s.sessions)} />
              <KpiCard label="Пользователи" value={fmtNum(s.visitors)} />
              <KpiCard label="Просмотры" value={fmtNum(s.pageviews)} />
              <KpiCard label="Отказы" value={fmtPct(s.bounce_rate)} />
            </div>
            <div className={styles.grid2}>
              {bySource.length > 0 && (
                <div>
                  <div style={{ color: "var(--text-dim)", fontSize: 12.5, marginBottom: 8 }}>
                    Источники трафика (визиты)
                  </div>
                  <DoughnutChart labels={bySource.map(([k]) => k)} values={bySource.map(([, v]) => v)} />
                </div>
              )}
              {searches.length > 0 && (
                <div>
                  <div style={{ color: "var(--text-dim)", fontSize: 12.5, marginBottom: 8 }}>
                    Поисковые запросы (топ)
                  </div>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    {searches.slice(0, 8).map((q, i) => (
                      <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderBottom: "1px solid var(--border)", fontSize: 13 }}>
                        <span style={{ color: "var(--text)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", marginRight: 12 }} title={q.phrase}>{q.phrase}</span>
                        <b style={{ flexShrink: 0 }}>{fmtNum(q.visits)}</b>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </Card>
        );
      })}
    </div>
  );
}
